'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reducers = require('../utils/reducers');

var getInitialState = function getInitialState() {
  return {
    // contents: {
    //   /* contentId: { contentId, url, isLoading, title, tags } */
    //   '0': {
    //     contentId: '0',
    //     type: 'url',
    //     title: '快速上手 Mindself',
    //     timestamp: Date.now(),
    //     image: {
    //       uri:
    //         'https://quip.com/-/blob/SeMAAAFkflw/PJeofE05KP9akLpDetJScA?s=zB7oAncZlGYg',
    //     },
    //     contentPreview: '​當你看到想保存的內容，除了複製連結之外，還有更快的方法存到 Mindself 哦！',
    //     domain: 'mindself.com',
    //     url: 'https://quip.com/zB7oAncZlGYg',
    //     tags: ['App', '分享', '儲存'],
    //     usedTags: ['歡迎', '教學', 'Mindself'],
    //     isLoading: true,
    //   },
    // },
    listContent: (0, _reducers.getFetchSubState)('initial'),
    createContent: (0, _reducers.getFetchSubState)('initial'),
    getContent: (0, _reducers.getFetchSubState)('initial'),
    removeContent: (0, _reducers.getFetchSubState)('initial'),
    editContent: (0, _reducers.getFetchSubState)('initial'),
    createURL: (0, _reducers.getFetchSubState)('initial'),
    createArticle: (0, _reducers.getFetchSubState)('initial'),
    createImage: (0, _reducers.getFetchSubState)('initial'),
    createAudio: (0, _reducers.getFetchSubState)('initial'),
    createVideo: (0, _reducers.getFetchSubState)('initial'),
    createImageSet: (0, _reducers.getFetchSubState)('initial'),
    createAudioSet: (0, _reducers.getFetchSubState)('initial'),
    createVideoSet: (0, _reducers.getFetchSubState)('initial')
  };
};
var initialState = getInitialState();

var actionsMap = _extends({
  resetFetchSubState: function resetFetchSubState(state /*, action*/) {
    return _extends({}, state, getInitialState());
  }
}, (0, _reducers.fetchReducer)('listContent', { resultName: true }), (0, _reducers.fetchReducer)('createContent', { resultName: true }), (0, _reducers.fetchReducer)('getContent', { resultName: true }), (0, _reducers.fetchReducer)('removeContent'), (0, _reducers.fetchReducer)('editContent'), (0, _reducers.fetchReducer)('createURL', { resultName: true }), (0, _reducers.fetchReducer)('createArticle', { resultName: true }), (0, _reducers.fetchReducer)('createImage', { resultName: true }), (0, _reducers.fetchReducer)('createAudio', { resultName: true }), (0, _reducers.fetchReducer)('createVideo', { resultName: true }), (0, _reducers.fetchReducer)('createImageSet', { resultName: true }), (0, _reducers.fetchReducer)('createAudioSet', { resultName: true }), (0, _reducers.fetchReducer)('createVideoSet', { resultName: true }));

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var reduceFn = actionsMap[action.type];
  if (!reduceFn) return state;
  return reduceFn(state, action);
};


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/reducers/content.js
// module id = 515
// module chunks = 1